import { ReactComponent as AndroidIcon } from "../../../assets/img/icon/android_black_24dp.svg";
import { RESPINOS_LINK } from "../../../config/constant";
import CardDashboard from "../../ui/atoms/CardDashboard/CardDashboard";
import PageTitle from "../../ui/atoms/PageTitle/PageTitle";

const AboutPage = () => {
  return (
    <>
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Tentang Aplikasi"
          description="Informasi aplikasi Respinos"
          icon={
            <AndroidIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />
        <div className="mt-12 md:mt-16">
          <CardDashboard
            title="Respinos Web App"
            icon={<AndroidIcon fill="#fafafa" className="w-5 h-5" />}
          >
            <p className="mt-3">
              Respinos Web Application adalah aplikasi berbasis web yang
              berfungsi untuk melakukan manajemen data pasien, rekam medis, dan
              perangkat respinos. Aplikasi ini bisa memudahkan pengguna untuk
              melakukan monitoring kondisi respirasi pasien.
            </p>
            <p className="mt-2">
              Pengembangan aplikasi ini merupakan kerja sama antara PT Xirka
              Silicon Technology beserta kampus ternama di Indonesia, yakni
              Institut Teknologi Bandung, Universitas Padjadjaran, dan
              Universitas Airlangga.
            </p>
            <p className="mt-2">
              Aplikasi respinos juga tersedia dalam aplikasi android. silakan
              download di{" "}
              <a
                href={RESPINOS_LINK.android}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="text-primary underline">sini</span>
              </a>{" "}
              untuk mengunduh aplikasi.
            </p>
          </CardDashboard>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
